module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921125649_T.69091e26.jpg";